export default "__VITE_ASSET__xGM4nMa4__"